/**
 * This module manages the state for the Gameplay Analysis request flow.
 * TODO: Move over relevant states from the Instapro/Vod module
 */

import _ from "lodash"
import { OFFER_DEFAULT, OFFER_MIN, OFFER_STEP, GAMEPLAY_UPLOAD_STEPS } from "./gameplay-analysis.constants"
import { formatValidOfferStepAmount } from "./gameplay-analysis.utils"

const state = () => ({
  isModalVisible: false,
  userFlowSource: null, // Where the user initiates the GPA funnel from
  gameplayUploadStep: GAMEPLAY_UPLOAD_STEPS.HOW_TO,
  offerAmount: OFFER_DEFAULT,
})

const mutations = {
  SET_MODAL_VISIBILITY: (state, isVisible) => {
    state.isModalVisible = isVisible
  },
  SET_USER_FLOW_SOURCE: (state, source) => {
    state.userFlowSource = source
  },
  SET_GAMEPLAY_UPLOAD_STEP: (state, step) => {
    state.gameplayUploadStep = step
  },
  SET_OFFER_AMOUNT: (state, amount) => {
    state.offerAmount = amount
  },
  DECREMENT_OFFER_AMOUNT: (state) => {
    state.offerAmount = formatValidOfferStepAmount(Math.max(state.offerAmount - OFFER_STEP, OFFER_MIN))
  },
  INCREMENT_OFFER_AMOUNT: (state) => {
    state.offerAmount = formatValidOfferStepAmount(state.offerAmount + OFFER_STEP)
  },
}

const actions = {
  toggleModalVisibility: ({ state, commit }, isVisible) => {
    commit("SET_MODAL_VISIBILITY", _.isNil(isVisible) ? !state.isModalVisible : !!isVisible)
  },
  startGameplayAnalysisFlow: ({ commit, dispatch, rootGetters }, source) => {
    commit("SET_USER_FLOW_SOURCE", source || null)
    dispatch("toggleModalVisibility", true)
  },
  setGameplayUploadStep: ({ commit }, step) => {
    commit("SET_GAMEPLAY_UPLOAD_STEP", step)
  },
  setOfferAmount: ({ commit }, amount) => {
    const boundedAmount = Math.max(amount, OFFER_MIN)
    commit("SET_OFFER_AMOUNT", boundedAmount)
  },
  decrementOfferAmount: ({ commit }) => {
    commit("DECREMENT_OFFER_AMOUNT")
  },
  incrementOfferAmount: ({ commit }) => {
    commit("INCREMENT_OFFER_AMOUNT")
  },
}

const getters = {
  isModalVisible: state => state.isModalVisible,
  userFlowSource: state => state.userFlowSource,
  checkGameGameplayAnalysisSupport: (state, getters, rootState, rootGetters) => gameKey => {
    const availableGames = rootGetters["Instapro/Vod/availableGames"] || []
    return availableGames.find(game => game.name === gameKey) !== undefined
  },
  gameplayUploadStep: state => state.gameplayUploadStep,
  offerAmount: state => state.offerAmount,
  offerCurrency: (state, getters, rootState, rootGetters) => rootGetters["User/Payment/activeCurrency"] || "USD",
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}



// WEBPACK FOOTER //
// ./src/store/coaching/gameplay-analysis/gameplay-analysis.module.js